module.exports = __webpack_public_path__ + "static/media/blue-eye.b2dad247.svg";